module.exports = __webpack_public_path__ + "r-v3/img/stopwatch_basic_dark.9a475f92.svg";